import React from "react"
import { useTranslation } from "react-i18next"
import { MagnifyingGlass, X } from "@phosphor-icons/react"
import { inputVariant } from "@/components/ui/input"
import { cn } from "@/lib/utils"

interface SearchBoxProps extends Omit<React.HTMLAttributes<HTMLDivElement>, "onChange"> {
  value: string
  onChange: (value: string) => void
  onClear: () => void
}

const SearchBox = ({ value, onChange, onClear, className, ...props }: SearchBoxProps) => {
  const { t } = useTranslation()

  return (
    <div className={cn("relative w-75", className)} {...props}>
      <input
        id="search"
        data-testid="treatment-template-list-search-input"
        value={value}
        placeholder={t("common.search")}
        className={cn(inputVariant(), "peer bg-surface hover:bg-surface focus:bg-surface h-12 pt-0 pr-20 pl-4")}
        autoComplete="off"
        aria-autocomplete="none"
        onChange={({ target }) => onChange(target.value)}
      />
      <span
        className="hover:bg-surface-hovered visible absolute top-1/2 right-10 -translate-y-1/2 cursor-pointer rounded-full p-1 transition-all peer-placeholder-shown:invisible"
        onClick={onClear}>
        <X className="text-on-surface-subdued h-6 w-6 cursor-pointer" />
      </span>
      <label htmlFor="search" className="absolute top-1/2 right-2 -translate-y-1/2">
        <MagnifyingGlass className="text-on-surface-subdued" />
      </label>
    </div>
  )
}

export { SearchBox }
